import lgmMixin from '~/mixins/lgmMixin';

export default {

    data() {
      return {
        componentRendered: false,
        promotionBannerLoadedCount: 0,
      };
    },  
    mixins: [lgmMixin],
    
    computed: {
    },
    created() {
    },
    mounted() {
      this.setEventTrackingListenersForInsurerPage()
    },
    beforeRouteUpdate(to, from, next) {
      next();
    },
    beforeUpdate() {
    },
    updated() {
      this.listenerTasks = [];
      this.setEventTrackingListenersForInsurerPage()
      this.listenerTasks.forEach((task) => task())
    },
  
    methods: {
      isBlogLink(el) {
        const href = el.getAttribute('href');
        const patternBlog = /^.*\/blog\/.*$/;

        if(href.match(patternBlog)) {
            return true;
        }
        return false;
      },
      isProductDetailLink(el) {
        const patternProducts = /^.*\/products\/.*$/;
        if (el.match(patternProducts)) {
          return true;
        }
        return false;
      },
      getHrefFromClickableElement(el) {
        let href
        if (!href && el?.getAttribute) {
          href = el?.getAttribute('href') || null;
        }
        if (!href) {
          href = el?.target?.getAttribute('href');
        }
        if (!href) {
          href = el?.target?.parentElement?.getAttribute('href');
        }
        if (!href) {
          href = el?.target?.parentElement?.parentElement?.getAttribute('href');
        }
        return href
      },
  
      isLinkInProductSection(el) {
        const node = el.closest('.products');
        if (node) {
          return true;
        }
        return false;
      },
      isLinkInBannerButton(el) {
        const node = el.closest('.promotion-banner-responsive-section');
        if (node) {
          return true;
        }
        return false;
      },
      isLinkInImageBanner(el) {
        const node = el.closest('.full-width-banner-section');
        if (node) {
          return true;
        }
        return false;
      },
      isLinkInTextSection(el) {
        const node = el.closest('.text-section');
        if (node) {
          return true;
        }
        return false;
      },
      isFavButton(el) {
        if (el == 'fav-action-button') {
            return true;
        }
        return false;
      },
      isProductWebsite(el) {
        const node = el.closest('.product-website');
        if (node) {
            return true;
        }
        return false;
      },
  
      setEventTrackingListenersForInsurerPage() {
        this.listenerTasks.push(
          this.eventTrackingListenersForInsurerPage
          )
  
      },

      eventTrackingListenersForInsurerPage() {
        const productCardItems = document.querySelectorAll('a.product-link.product-card-link');

        const productCtaButtons = document.querySelectorAll('a.product-card-cta-link');
        const productPromoButtons = document.querySelectorAll('a.cta-button.product-promo-cta');
        const productFavButtons = document.querySelectorAll('.fav-action-button');

        if (productCtaButtons) {
            const item = productCtaButtons;
            const self = this;
            item.forEach((el) => {
                const dataFromClickableElement = self.extractDataFromClickedElement(el);
                const href = dataFromClickableElement?.href;
                if (self.isTransitionLink(href)) {
                    // #217 Online Sales
                    if (self.isProductWebsite(el)) {
                        el.addEventListener('click', self.handleEventTracking_InsurerProductCardClickToProductWebsiteNonPaid)
                    } else {
                        // #212 click_redirection
                        el.addEventListener('click', self.handleEventTracking_InsurerProductCardClickRedirection)
                    }
                }

                // #214 Broker enquiry
                if (self.isWhatsappLink(href)) {
                    el.addEventListener('click', self.handleEventTracking_InsurerProductCardClickOpenWhatsapp)
                }
                
                // #215 Online Sales
                if (self.isEComLink(href)) {
                    el.addEventListener('click', self.handleEventTracking_InsurerProductCardClickToEcom)
                }
            })
        }
        if (productPromoButtons) {
            const item = productPromoButtons;
            const self = this;
            item.forEach((el) => {
                const dataFromClickableElement = self.extractDataFromClickedElement(el);
                const href = dataFromClickableElement?.href;
                // #213 click_redirection
                if (self.isTransitionLink(href)) {
                    el.addEventListener('click', self.handleEventTracking_InsurerProductCardPromoClickRedirection)
                }
                // #216 Online Sales
                if (self.isEComLink(href)) {
                    el.addEventListener('click', self.handleEventTracking_InsurerProductCardPromoClickToEcom)
                }
            })
        }
        if (productFavButtons) {
            const item = productFavButtons;
            const self = this;
            item.forEach((el) => {
                const dataFromClickableElement = self.extractDataFromClickedElement(el);
                const className = dataFromClickableElement?.class;
                // #218 Engagement
                if (self.isFavButton(className)) {
                    el.addEventListener('click', self.handleEventTracking_InsurerProductCardClickFavButton)
                }

            })
        }
        if (productCardItems) {
            const item = productCardItems;
            const self = this;
            item.forEach((el) => {
                const dataFromClickableElement = self.extractDataFromClickedElement(el);
                const href = dataFromClickableElement?.href;
                // #223 Engagement
                if (self.isProductDetailLink(href)) {
                    el.addEventListener('click', self.handleEventTracking_InsurerProductCardClickToDetailPage)
                }

            })
        }
      },
        
        // #212 click_redirection
        // insurer_decoder_card_cta
        handleEventTracking_InsurerProductCardClickRedirection(event) {
            const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
            const parentOfClickedElement = event.target.offsetParent;
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'click_redirection';
            eventTrackingParams.l = productScenarioCode; 
            eventTrackingParams.c = 'insurer_decoder_card_cta';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            this.$goToURL(dataFromClickedElement.href , false, eventTrackingParams, {
              getLGMConversionId: this.getLGMConversionId,
              injectLGMConversionId: this.injectLGMConversionId,
              injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
            })
            
            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #213 click_redirection
        // insurer_decoder_promo_cta
        handleEventTracking_InsurerProductCardPromoClickRedirection(event) {
            const parentOfClickedElement = event.target.offsetParent.offsetParent
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'click_redirection';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'insurer_decoder_promo_cta';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #214 open_whatsapp
        // insurer_decoder_card_cta
        handleEventTracking_InsurerProductCardClickOpenWhatsapp(event) {
            const parentOfClickedElement = event.target.offsetParent;
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'open_whatsapp';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'insurer_decoder_card_cta';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #215 to_ecom_site
        // Insurer_decoder_card_cta
        handleEventTracking_InsurerProductCardClickToEcom(event) {
            const parentOfClickedElement = event.target.offsetParent;
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'to_ecom_site';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'insurer_decoder_card_cta';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #216 to_ecom_site
        // insurer_decoder_promo_cta
        handleEventTracking_InsurerProductCardPromoClickToEcom(event) {
            const parentOfClickedElement = event.target.offsetParent.offsetParent
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'to_ecom_site';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'insurer_decoder_promo_cta';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #217 product_website
        // Insurer_decoder_card_cta
        handleEventTracking_InsurerProductCardClickToProductWebsiteNonPaid(event) {
            const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
            const parentOfClickedElement = event.target.parentElement.offsetParent
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'product_website';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'Insurer_decoder_card_cta';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            this.$goToURL(dataFromClickedElement.href , false, eventTrackingParams, {
              getLGMConversionId: this.getLGMConversionId,
              injectLGMConversionId: this.injectLGMConversionId,
              injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
            })

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #218 save_product
        // insurer_decoder_card_icon
        handleEventTracking_InsurerProductCardClickFavButton(event) {
            const parentOfClickedElement = event.target.parentElement.offsetParent
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'save_product';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'insurer_decoder_card_icon';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        },
        // #223 open_product_details
        // insurer_decoder_card
        handleEventTracking_InsurerProductCardClickToDetailPage(event) {
            const parentOfClickedElement = event.target
            const insuranceCompany = parentOfClickedElement.getAttribute("data-insurer-company")
            const productScenarioCode = parentOfClickedElement.getAttribute("data-product-id")
            const productName = parentOfClickedElement.getAttribute("data-product-name")
            const productCategory = parentOfClickedElement.getAttribute("data-product-category")
            // const href = dataFromClickedElement?.href;
            const eventTrackingParams = this.initEventTrackingParams()

            // const data = this.extractDataFromTransitionLink(href);
            eventTrackingParams.a = 'open_product_details';
            eventTrackingParams.l = productScenarioCode;
            eventTrackingParams.c = 'insurer_decoder_card';
            eventTrackingParams.cd.insurer_name = insuranceCompany;
            eventTrackingParams.cd.product_name = productName;
            eventTrackingParams.cd.product_category = productCategory;

            if(eventTrackingParams.a !== ''){
                this.sendEventTracking(eventTrackingParams)
              }
        }


    },
    
    watch: {
    }
  };